import React from "react";

interface Props {
  base64?: string | null;
}

/**
 * 🔲 QzTrayPreviewQr
 *
 * Renderiza el código QR del ticket en formato Base64.
 * Ajustado con mayor tamaño y mejor integración visual.
 */
const QzTrayPreviewQr: React.FC<Props> = ({ base64 }) => {
  if (!base64) {
    return (
      <div className="flex items-center justify-center w-40 h-40 bg-gray-100 dark:bg-gray-800 rounded-md text-gray-500 text-sm italic border border-stroke dark:border-strokedark shadow-sm mt-4">
        Sin QR
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center mt-5">
      <div className="border border-stroke dark:border-strokedark rounded-md shadow-md p-2 bg-white dark:bg-gray-900">
        <img
          src={`data:image/png;base64,${base64}`}
          alt="Código QR del ticket"
          className="w-40 h-40 object-contain"
        />
      </div>

      <p className="mt-2 text-xs text-gray-600 dark:text-gray-400 italic text-center">
        Código QR del ticket
      </p>
    </div>
  );
};

export default QzTrayPreviewQr;
